module.exports = __webpack_public_path__ + "media/site/images/voicetalents-slider/voicetalents_screens-03-735cb39944a76fd096a448de5b5f4e0b.jpg";